import Auth from '../api/auth';

const parseErrorCode = error => Promise.reject(error);

export default axios => {
  const { apiHost = '' } = window.chatwootConfig || {};
  const wootApi = axios.create({ baseURL: `${apiHost}/` });
  // Add Auth Headers to requests if logged in
  if (Auth.hasAuthCookie()) {
    const {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    } = Auth.getAuthData();
    Object.assign(wootApi.defaults.headers.common, {
      'access-token': accessToken,
      'token-type': tokenType,
      client,
      expiry,
      uid,
    });
  }
  // Response parsing interceptor
  wootApi.interceptors.response.use(
    response => response,
    error => {
      if (
        error?.response?.status === 403 &&
        error?.response?.data?.error === 'mfa_setup_required' &&
        !window.location.pathname.includes('/setup-mfa')
      ) {
        const match = window.location.pathname.match(/\/app\/accounts\/(\d+)/);
        const accountId = match ? match[1] : '';
        if (accountId) {
          window.location.href = `/app/accounts/${accountId}/setup-mfa`;
          return new Promise(() => {});
        }
      }
      return parseErrorCode(error);
    }
  );
  return wootApi;
};
